<div class="headermaster">
  <div class="row">
    <div class="col-md-4 pl-0">
      <nav class="navbar navbar-expand-sm top-banner">
        <img src="../../assets/images/logo.png" width="80" />
        <ul class="navbar-nav ml-2">
          <li class="nav-item">
            <div class="contentheader">สถาบันคุ้มครองเงินฝาก (สคฝ.)</div>
            <div class="contentheader2">Deposit Protection Agency(DPA)</div>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</div>
<div class="row mt-5">
  <div class="col-5 my-auto mx-auto bg-white p-3 rounded border-top border-primary">
    <div class="row">
      <div class="col-12 text-center">
        <h3 class="text-primary">กำหนดรหัสผ่านใหม่</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <form>
          <div class="form-group">
            <label for="username">Username</label>
            <input type="text" class="form-control" name="username" [(ngModel)]="username">
            <span class="text-danger" *ngIf="submitted && username.trim() == ''">
              กรุณาระบุ Username
            </span>
            <span class="text-secondary">ระบบจะส่ง email เพื่อให้กำหนดรหัสผ่านใหม่ ไปให้ตาม email ที่ได้ลงทะเบียนไว้</span>
          </div>
        </form>

      </div>
      <div class="col-12 text-center">
        <button type="button" class="btn btn-primary m-2" (click)="checkUsername()">ตั้งค่ารหัสผ่านใหม่ของฉัน</button>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/reset-password/reset-password.component.html